import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { useState, useEffect } from 'react';

const COLORS = ["#783BFF", "#7FB1BA", "#01085A"];

export default function DailyStatus({ dailyNoteStatus, setOpenTotalModal, setOpenWeeklyModal, setOpenDailyModal, openDailyModal, openWeeklyModal, openTotalModal, doctor_name, access_token }) {
  const [pieData, setPieData] = useState(null);
  const [total, setTotal] = useState(null);

  useEffect(() => {
    setTotal(dailyNoteStatus.total);

    if (dailyNoteStatus !== null) {
      if (access_token) {
        setPieData(
          [
            { name: "Ready to Record", value: dailyNoteStatus.record },
            { name: "Review", value: dailyNoteStatus.review },
            { name: "Locked", value: dailyNoteStatus.locked }
          ]
        )
      } else {
        setPieData(
          [
            { name: "Ready to Record", value: dailyNoteStatus.record },
            { name: "Review", value: dailyNoteStatus.review }
          ]
        )
      }
    }

  }, [openWeeklyModal, openTotalModal, openDailyModal])

  const customLegend = (value, entry) => {
    const { value: chartVal } = entry.payload;

    if (total !== 0) {
      return `${value}: ${chartVal} - ${((chartVal / total) * 100).toFixed(2)}%`;
    } else {
      return `${value}: ${chartVal}`;
    }
  }

  const handleTotalClick = () => {
    setOpenTotalModal(true);
    setOpenWeeklyModal(false);
    setOpenDailyModal(false);
  }

  const handleWeeklyClick = () => {
    setOpenWeeklyModal(true);
    setOpenTotalModal(false);
    setOpenDailyModal(false);
  }

  const closeDailyModal = () => {
    setOpenDailyModal(false);
  }

  return (
    <div className='fixed left-[28%] top-[28%] w-[50%] flex flex-col items-center justify-center bg-light-purple p-4 rounded-md shadow-md z-10'>
      <button onClick={handleWeeklyClick}>Show Weekly</button>
      <button onClick={handleTotalClick}>Show Historical</button>
      <h2 className='text-[26px]'>Daily Note Status for {doctor_name}</h2>
      <h3 className='text-[22px]'>Integrated?: {access_token ? "Yes" : "No"}</h3>
      <button className='absolute right-[20px] top-[10px] hover:text-ktx-navy font-bold text-[26px]' onClick={closeDailyModal}>×</button>

      {total !== 0 ? (<div className='relative w-full h-full z-10'>
        <ResponsiveContainer width={"96%"} height={400}>
          <PieChart>
            <Pie
              data={pieData}
              cx={"42%"}
              cy={"40%"}
              labelLine={false}
              outerRadius={160}
              fill="#8884d8"
              dataKey="value"
            >
              {pieData !== null && pieData.map((_, i) => (
                <Cell key={`cell-${i}`} fill={COLORS[i % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend layout="vertical" align="right" iconType="circle" iconSize={10} verticalAlign='middle' formatter={customLegend} />
          </PieChart>
        </ResponsiveContainer>
      </div> ) : <div>No Notes Yet Today</div>}
      
    </div>
  )
}